import type { FeatureFlags } from '../contexts/ApplicationContext';

// U.S. territories and freely associated states, which are not serviceable because of tax implications.
export const US_NON_STATE_ABBR_LIST = ['AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'];

export const US_STATES_ABBR_LIST = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'FM',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'VI',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const US_STATES_ABBR_LIST_EXCLUDING_TERRITORIES = US_STATES_ABBR_LIST.filter(
  (abbr) => !US_NON_STATE_ABBR_LIST.includes(abbr),
);

export const REPORTS_EXPIRED_TEXT = 'Credit and background reports have expired';
export const APPLICATION_NOT_SAVED_TEXT = 'We couldn’t save your application. Try again or refresh the page.';

export const displayDateFormat = 'LLLL d, yyyy';

export const filteredKeys = new Set<string>(['__typename', 'areDocumentsExpired', 'coapplicants']);
export const topLevelFilteredKeys = ['id', 'email'];

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {};
